import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';

export const StyledPlaydogBundle = styled.div<{ priceDisplay: string }>`
  box-sizing: border-box;
  font-family: ${(props: any) => props.fontFamily};
  width: 100%;
  max-width: 166px;
  min-width: 166px;
  height: 200px;
  position: relative;
  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : createGradientOrSolid(props.backgroundColor)};
  padding: 4px 0 0;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 1px 0 rgba(255, 255, 255, 0.4) inset,
    0 4px 4px 0 rgba(0, 0, 0, 0.25) inset;
  border-radius: 16px;
  overflow: hidden;

  .playdog-bundle {
    &-products {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      padding: 0 16px;

      &__sub {
        gap: 4px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        max-width: 120px;
        margin: auto auto 10px;
      }
    }
  }

  .price {
    border-radius: 0 0 16px 16px;
    box-shadow: 0 4px 4px 0 rgba(255, 255, 255, 0.25) inset,
      0 4px 4px 0 rgba(0, 0, 0, 0.15);
    z-index: 1;
    min-height: 32px;
    height: 32px;

    .totalPrice {
      .final-price {
        background: -webkit-linear-gradient(#fdf9fb 34.38%, #affeac 81.25%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-shadow: none;
        position: relative;

        &:after {
          background: none;
          content: '${({ priceDisplay }) => CSS.escape(priceDisplay || '')}';
          left: 0;
          top: 0;
          z-index: -1;
          position: absolute;
          text-shadow: 1px 1px 0px #033a01, -1px -1px 0px #033a01,
            1px -1px 0px #033a01, -1px 1px 0px #033a01;
        }
      }
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    width: 204px;
    max-width: 204px;
    height: 247px;
    padding-top: 5px;
    border-radius: 20px;

    .playdog-bundle {
      &-products {
        padding: 0 18x;

        &__sub {
          gap: 5px;
          max-width: 140px;
          margin: auto auto 15px;
        }
      }
    }

    .price {
      min-height: 40px;
      height: 40px;
      border-radius: 0 0 20px 20px;

      .totalPrice {
        .final-price {
          font-size: calc(clamp(4px, 1em * 1.67, 20px));
        }
      }
    }
  }
` as any;

export const StyledMainProduct = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .product-img {
    height: 68px;
    width: 68px;
    display: flex;
    justify-content: center;

    .image {
      height: 68px;
      width: auto;
      object-fit: contain;
    }
  }

  .content-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    font-size: 12px;

    .stroked-container,
    .quantity-container {
      padding: 0 4px;
      z-index: 1;
      width: 100%;
      text-align: center;
      justify-content: center;
    }

    .quantity-container {
      width: 128px;
      margin: 0 auto;
      &__value {
        justify-content: center;
        align-items: center;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        background: -webkit-linear-gradient(#fef571 18.75%, #ffcb03 81.25%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        position: relative;
        line-height: 20px;

        &:after {
          background: none;
          content: attr(data-main);
          left: 0;
          top: 0;
          z-index: -1;
          position: absolute;
          text-shadow: 0 1px 1px rgba(0, 0, 0, 0.8);
        }
      }
    }

    .stroked-container {
      width: 98px;
      margin: 0 auto;
      &__value {
        font-style: normal;
        line-height: normal;
        color: #83a9f8;
        text-shadow: 0 1px 0 rgba(0, 0, 0, 0.8);
        position: relative;
        font-weight: 700;

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 102%;
          height: 1px;
          background: #83a9f8;
        }
      }
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    .product-img {
      height: 84px;
      width: 84px;

      .image {
        height: 84px;
      }
    }

    .content-container {
      .quantity-container {
        width: 100%;
        &__value {
          line-height: 24px;
        }
      }
      .stroked-container {
        width: 100%;
      }
    }
  }
` as any;

export const StyledSubProduct = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .product-info {
    display: flex;
    align-items: center;

    .product-img {
      min-width: 20px;
      max-height: 20px;
      width: 100%;
      max-height: 20px;
      max-width: 26px;
      display: flex;
      justify-content: center;
      align-items: center;

      .image {
        height: 20px;
        width: auto;
        max-width: 26px;
        object-fit: contain;
      }
    }

    .price-container {
      width: 100%;
      margin-left: 4px;
      max-width: 40px;
      z-index: 1;

      .quantity-container {
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        background: -webkit-linear-gradient(#fefeff 34.38%, #c1ffff 81.25%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        position: relative;
        font-size: calc(clamp(4px, 1em * 0.75, 12px));

        &:after {
          background: none;
          content: attr(data-sub);
          left: 0;
          top: 0;
          z-index: -1;
          position: absolute;
          text-shadow: 0 0.77px 0.77px rgba(0, 0, 0, 0.8);
        }
      }
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    .product-info {
      .product-img {
        min-width: 24px;
        max-height: 24px;
        max-height: 24px;
        max-width: 28px;

        .image {
          height: 24px;
          max-width: 26px;
        }
      }

      .price-container {
        .quantity-container {
          font-size: calc(clamp(4px, 1em * 1, 16px));
        }
      }
    }
  }
` as any;
//   margin-top: 8px;
//   font-family: ${({ fontFamily }: any) => fontFamily};
//   background: var(--button-bg-color);
//   display: flex;
//   direction: ltr;
//   justify-content: center;
//   align-items: center;
//   color: var(--button-text-color);
//   position: relative;
//   border-radius: 4px;
//   width: 100%;
//   min-height: 31px;
//   height: 31px;
//   border-bottom: 1px solid #31d9f8;
//   box-shadow: 0px -1px 4.3px 0px #14fd29 inset;

//   .totalPrice {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     padding: 0 5px;
//     z-index: 10;
//     white-space: nowrap;
//     font-weight: 700;
//     width: 100%;

//     span,
//     .final-price,
//     .stroked {
//       text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3),
//         -0.5px 0.5px 0 rgb(0, 101, 43), 0.5px -0.5px 0 rgb(0, 101, 43),
//         -0.5px -0.5px 0 rgb(0, 101, 43), 0.5px 0.5px 0 rgb(0, 101, 43);
//     }

//     .stroked {
//       font-size: calc(clamp(4px, 1em * 0.75, 12px));
//     }
//   }
// ` as any;
